/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-common-spacing">
	<template>
		<custom-style>
			<style>
            :host([spacing-top=small]) {
                margin-top: var(--cs-small-component-space-mobile)
            }

            :host([spacing-bottom=small]) {
                margin-bottom: var(--cs-small-component-space-mobile)
            }

            :host([spacing-top=medium]) {
                margin-top: var(--cs-medium-component-space-mobile)
            }

            :host([spacing-bottom=medium]) {
                margin-bottom: var(--cs-medium-component-space-mobile)
            }

            :host([spacing-top=large]) {
                margin-top: var(--cs-large-component-space-mobile)
            }

            :host([spacing-bottom=large]) {
                margin-bottom: var(--cs-large-component-space-mobile)
            }

            @media only screen and (min-width:768px) {
                :host([spacing-top=small]) {
                    margin-top: var(--cs-small-component-space-tablet-portrait)
                }

                :host([spacing-bottom=small]) {
                    margin-bottom: var(--cs-small-component-space-tablet-portrait)
                }

                :host([spacing-top=medium]) {
                    margin-top: var(--cs-medium-component-space-tablet-portrait)
                }

                :host([spacing-bottom=medium]) {
                    margin-bottom: var(--cs-medium-component-space-tablet-portrait)
                }

                :host([spacing-top=large]) {
                    margin-top: var(--cs-large-component-space-tablet-portrait)
                }

                :host([spacing-bottom=large]) {
                    margin-bottom: var(--cs-large-component-space-tablet-portrait)
                }
            }

            @media only screen and (min-width:1024px) {
                :host([spacing-top=small]) {
                    margin-top: var(--cs-small-component-space-tablet-landscape)
                }

                :host([spacing-bottom=small]) {
                    margin-bottom: var(--cs-small-component-space-tablet-landscape)
                }

                :host([spacing-top=medium]) {
                    margin-top: var(--cs-medium-component-space-tablet-landscape)
                }

                :host([spacing-bottom=medium]) {
                    margin-bottom: var(--cs-medium-component-space-tablet-landscape)
                }

                :host([spacing-top=large]) {
                    margin-top: var(--cs-large-component-space-tablet-landscape)
                }

                :host([spacing-bottom=large]) {
                    margin-bottom: var(--cs-large-component-space-tablet-landscape)
                }
            }

            @media only screen and (min-width:1456px) {
                :host([spacing-top=small]) {
                    margin-top: var(--cs-small-component-space-desktop)
                }

                :host([spacing-bottom=small]) {
                    margin-bottom: var(--cs-small-component-space-desktop)
                }

                :host([spacing-top=medium]) {
                    margin-top: var(--cs-medium-component-space-desktop)
                }

                :host([spacing-bottom=medium]) {
                    margin-bottom: var(--cs-medium-component-space-desktop)
                }

                :host([spacing-top=large]) {
                    margin-top: var(--cs-large-component-space-desktop)
                }

                :host([spacing-bottom=large]) {
                    margin-bottom: var(--cs-large-component-space-desktop)
                }
            }

            :host(:first-child),
            :host([spacing-top=none]) {
                margin-top: 0
            }

            :host(:last-child),
            :host([spacing-bottom=none]) {
                margin-bottom: 0
            }
        </style>
		</custom-style>
	</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);